module.exports = __webpack_public_path__ + "2376a16e1a13340f5dd9362f54037ef1.svg";